export default __webpack_public_path__ + "static/media/logo.e04e4f10.jpg";